import TagConstants from 'constants/TagConstants'
import TagTypeEnum from 'constants/TagTypeEnum'

const TagStore = Marty.createStore({
  id: 'TagStore',
  getInitialState() {
    return {
      tagsById: {},
    }
  },

  handlers: {
    fetchTagListDone: TagConstants.TAG_LIST_FETCH_DONE,
    createTag: TagConstants.TAG_CREATE,
    updateTag: TagConstants.TAG_UPDATE,
    deleteTag: TagConstants.TAG_DELETE,
    pushTag: TagConstants.PUSH_TAG,
  },

  getOrFetchTagList() {
    return this.fetch({
      id: 'fetchTags',
      // gotta make sure the access token work
      dependsOn: [this.app.stores.UserStore.getOrFetchCurrentUser()],
      locally() {
        if (this.hasAlreadyFetched('fetchTags')) {
          return this.state.tagsById
        }
      },
      remotely() {
        return this.app.queries.TagQueries.fetchTagsForOrgId(
          this.app.stores.UserStore.getCurrentUser().orgId,
        )
      },
    })
  },

  getOrFetchConversationTagList() {
    return this.fetch({
      id: 'fetchConversationTags',
      dependsOn: [this.getOrFetchTagList()],
      locally() {
        return _.filter(this.state.tagsById, tag => tag.targetType === TagTypeEnum.CONVERSATION.key)
      },
    })
  },

  getOrFetchCustomerTagList() {
    return this.fetch({
      id: 'fetchCustomerTags',
      dependsOn: [this.getOrFetchTagList()],
      locally() {
        return _.filter(this.state.tagsById, tag => tag.targetType === TagTypeEnum.ANY.key)
      },
    })
  },

  getOrFetchCompanyTagList() {
    return this.fetch({
      id: 'fetchCompanyTags',
      dependsOn: [this.getOrFetchTagList()],
      locally() {
        return _.filter(this.state.tagsById, tag => tag.targetType === TagTypeEnum.ANY.key)
      },
    })
  },

  getOrFetchTagIdsForConversationId(conversationId) {
    return this.fetch({
      id: `getOrFetchTagListForConversationId${conversationId}`,
      dependsOn: [this.app.stores.ConversationStore.getOrFetchConversation(conversationId)],
      locally() {
        return this.app.stores.ConversationStore.getConversationById(conversationId).tags
      },
    })
  },

  getOrFetchTagIdsForEndUserId(endUserId) {
    return this.fetch({
      id: `getOrFetchTagListForEndUserId${endUserId}`,
      dependsOn: [this.app.stores.EndUserStore.getOrFetchEndUser(endUserId)],
      locally() {
        return this.app.stores.EndUserStore.getEndUser(endUserId).tags
      },
    })
  },

  getOrFetchTagIdsForCompanyId(companyId) {
    return this.fetch({
      id: `getOrFetchTagListForCompanyId${companyId}`,
      dependsOn: [this.app.stores.CompanyStore.getOrFetchCompany(companyId)],
      locally() {
        return this.app.stores.CompanyStore.getCompany(companyId).tags
      },
    })
  },

  fetchTagListDone(tags) {
    return this.setState({ tagsById: _.keyBy(tags, 'id') })
  },

  getTag(tagId) {
    return this.state.tagsById[tagId]
  },

  createTag(tagParams) {
    const { orgId } = this.app.stores.UserStore.getCurrentUser()
    return this.app.queries.TagQueries.createTagForOrgId(orgId, tagParams)
  },

  updateTag(tagId, tagParams) {
    const { orgId } = this.app.stores.UserStore.getCurrentUser()
    return this.app.queries.TagQueries.updateTagForOrgId(orgId, tagId, tagParams)
  },

  deleteTag(tagId) {
    const { orgId } = this.app.stores.UserStore.getCurrentUser()
    return this.app.queries.TagQueries.deleteTagForOrgId(orgId, tagId)
  },

  setTag(tag) {
    const tagsById = _.cloneDeep(this.state.tagsById)
    tagsById[tag.id] = tag
    return this.setState({ tagsById })
  },

  deleteTagById(tagId) {
    const tagsById = _.cloneDeep(this.state.tagsById)
    delete tagsById[tagId]
    return this.setState({ tagsById })
  },

  pushTag(tag) {
    if (tag.status === 'ARCHIVED') {
      return this.deleteTagById(tag.id)
    } else {
      return this.setTag(tag)
    }
  },
})

export default TagStore



// WEBPACK FOOTER //
// ./src/scripts/stores/TagStore.js